export class GetSteamInventory {
  public static readonly type = '[p2p] Get Steam Inventory';
  constructor(public ignoreCache?: boolean) {}
}
export class GetSteamStatus {
  public static readonly type = '[p2p] Get Steam Status';
}
